import React from 'react';
import { projects } from '../data/data';

const ProjectsSection = () => {
  return (
    <section id="projects" className="py-32 px-6 text-center">
      
      {/* TITLE */}
      <h2 className="text-4xl md:text-5xl font-bold mb-12">
        Projects <span className="text-cyan-400 glow">Built</span>
      </h2>

      {/* GRID */}
      <div className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
        
        {projects.map((project) => (
          <div
            key={project.id}
            className="bg-[#111]/60 backdrop-blur-lg border border-cyan-400/20 rounded-2xl p-8 text-left transition-all duration-300 hover:border-cyan-400 hover:shadow-[0_0_40px_rgba(0,255,255,0.2)] hover:scale-[1.02]"
          >

            {/* TITLE */}
            <h3 className="text-2xl font-bold text-cyan-400">
              {project.title}
            </h3>

            {/* SUBTITLE */}
            <p className="text-gray-400 mt-2 italic">
              {project.fullName}
            </p>

            {/* DESCRIPTION */}
            <p className="text-gray-300 mt-4 leading-relaxed">
              {project.description}
            </p>

            {/* TECH */}
            <div className="mt-4 text-sm text-gray-400">
              <span className="text-cyan-400 font-semibold">Tech:</span>{" "}
              {project.tech.join(", ")}
            </div>

            {/* STATUS */}
            <div className="mt-2 text-sm text-gray-400">
              <span className="text-cyan-400 font-semibold">Status:</span>{" "}
              {project.status}
            </div>

          </div>
        ))}

      </div>

    </section>
  );
};

export default ProjectsSection;